module.exports = __webpack_public_path__ + "img/template-01.279ce954.svg";